import axios from "axios";
import {message} from 'ant-design-vue';
import router from "@/router";
import store from "@/store";
import {getStorage, removeStorage} from '@/hook/useStorage'
import {USER_TOKEN, UPLOAD_URL, PROXY_ID, PROXY_TOKEN_STORAGE} from "@/hook/useConstant";


const {VUE_APP_API} = process.env

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。'
}

axios.defaults.withCredentials = true

// 创建 axios 实例
let instance = axios.create({timeout: 20000})

// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        if (getStorage(USER_TOKEN)) {
            config.headers['Authorization'] = 'bearer ' + getStorage(USER_TOKEN)
        }

        // 代登录账号时，需要将原账号id加上
        if (getStorage(PROXY_ID)) {
            config.headers['Proxyid'] = getStorage(PROXY_ID)
        }

        let _index = UPLOAD_URL.findIndex(item => config.url.indexOf(item) !== -1)
        if (_index > -1) {
            config.headers['Content-Type'] = 'multipart/form-data'
        } else {
            config.headers['Content-Type'] = 'application/json;charset=utf-8'
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        closeLoading()
        let {data} = response

        if (response.request.responseType === 'blob') {
            return response
        }

        if (data.code === 300) {
            message.error(data.msg || '服务异常')
            removeStorage(USER_TOKEN)
            removeStorage(PROXY_ID)
            removeStorage(PROXY_TOKEN_STORAGE)
            router.push('/login')
            return Promise.reject(data)
        }

        if (data.code !== 0) {
            message.error(data.msg || '服务异常')
            return Promise.reject(data)
        } else {
            return data
        }
    },
    error => {
        closeLoading()
        let code = error.response && error.response.status
        if (code === undefined && error.message.includes('timeout')) {
            code = 504
        }
        message.error(codeMessage[code])
        return Promise.reject(error)
    }
)
// 开启&&计算loading
const loadingFn = (config) => {
    return false
    // 启动loading
    store.commit('SET_SPINNING', true)
    // 计算loading数量
    store.commit('setSpinningCount', 1)
}
// 关闭&&计算loading
const closeLoading = () => {
    // 计算loading数量,当为0时隐藏loading
    store.commit('setSpinningCount', -1)
    if (store.state.spinningCount <= 0) {
        store.commit('SET_SPINNING', false)
    }
}

export const post = (url, params, config) => {
    // 去除首尾空格
    for (let key in params) {
        if (params[key] && typeof (params[key]) === 'string') {
            params[key] = params[key].replace(/(^\s*)|(\s*$)/g, '')
        }
    }
    loadingFn(config)
    url = `${VUE_APP_API}/admin${url}`
    return instance.post(url, params, config)
}

export const get = (url, params, config) => {
    loadingFn(config)
    url = `${VUE_APP_API}/admin${url}`
    return instance.get(url, {params}, config)
}

export const exportFile = (url, params) => {
    url = `${VUE_APP_API}/admin${url}`
    return instance.post(url, params, {responseType: 'blob'})
}


